<i18n src="@/i18n/template/components/OperateButtons.json"></i18n>
<template>
  <div
    style="
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
    "
  >
    <template v-if="buttons && buttons.length > 0">
      <el-button
        v-for="(button, index) in buttonsToShow"
        :key="index"
        style="margin-left: 0px"
        @click="button.action"
        type="text"
      >
        {{ button.label }}
      </el-button>
      <el-dropdown
        v-if="buttons.length > defaultBtnNumber"
        style="color: #4d03d4; font-size: 12px"
        :hide-on-click="false"
        @command="handleClick($event)"
      >
        <span>
          {{ $t('More') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(button, index) in dropdownButtons"
            :key="index"
            :command="button.command"
          >
            <span>{{ button.label }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    <template v-else>
      <template v-if="buttonsToShow.length > 0">
        <component
          v-for="(button, index) in buttonsToShow"
          :key="index"
          :is="button.componentOptions.Ctor"
          v-bind="button.data.attrs"
        ></component>
      </template>
      <el-dropdown
        v-if="showMoreButton"
        style="color: #4d03d4; font-size: 12px"
        :hide-on-click="false"
      >
        <span>
          {{ $t('More') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="(button, index) in dropdownButtons"
              :key="index"
            >
              <component
                :is="button.componentOptions.Ctor"
                v-bind="button.data.attrs"
              ></component>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    buttons: {
      type: Array,
      default: () => []
    },
    defaultBtnNumber: {
      type: Number,
      default: 2
    }
  },
  computed: {
    slotsButtonArr() {
      const slots = this.$slots.default || []
      return slots.filter(item => item.componentOptions)
    },
    buttonsToShow() {
      const buttonArray =
        this.buttons && this.buttons.length > 0
          ? this.buttons
          : this.slotsButtonArr
      return buttonArray.length <= this.defaultBtnNumber
        ? buttonArray
        : [buttonArray[0]]
    },
    showMoreButton() {
      const buttonArray =
        this.buttons && this.buttons.length > 0
          ? this.buttons
          : this.slotsButtonArr
      return buttonArray.length > this.defaultBtnNumber
    },
    dropdownButtons() {
      const buttonArray =
        this.buttons && this.buttons.length > 0
          ? this.buttons
          : this.slotsButtonArr
      return buttonArray.slice(1)
    }
  },
  methods: {
    handleClick(command) {
      this.$emit('handleClick', command)
    }
  }
}
</script>

<style scoped></style>
